import { combineEpics } from 'redux-observable';

import SignupEpics from '../modules/signup/epics';

export default combineEpics(
  SignupEpics
);
